// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-o_fS","advertDetailContacts__header":"c-o_fT"};